import React from 'react';
import styled from 'styled-components';
import EllipsesControl from '../../../../../../../Common/EllipsesControl/EllipsesControl';

export default function NameColumn(params) {
	const val = params.data && params.data.glAccountName ? params.data.glAccountName : params.value;
	return (
		<StyledNameColumn className="StyledNameColumn">
			{val && (
				<>
					<EllipsesControl noOfLines={1} content={val} tooltip={val} tooltipClass="tooltipCustomWidth" />
				</>
			)}
		</StyledNameColumn>
	);
}

const StyledNameColumn = styled.section`
	font-size: var(--px-14);
	font-weight: 400;
	line-height: var(--px-24);
`;
